export const CLAIMS_REPORTING_CONSTANTS = {
  UHC_INSIGHTS_ASSISTANT_TITLE: 'UHC Insights Assistant',
  UHC_INSIGHTS_ASSISTANT_DESCRIPTION:
    'Chat to explore UHC Insights data or build a custom report.',
  CHAT_TO_EXPLORE: 'Chat to Explore',
  ON_DEMAND_CLAIM_REPORTING: 'On Demand Claim Reporting',
  ON_DEMAND_TIN_LIMIT_ERROR: 'Your request exceeds the maximum limit of 50 TINs. Please reduce the number of TINs and try again.',
  // Generate Report Drawer
  CLAIMS_REPORTING_TITLE: 'Claims Reporting',
  REPORT_PARAMETERS: 'Report Parameters',
  REPORT_PARAMETERS_DESCRIPTION:
    'Configure the parameters below to generate a custom claims report.',
  REPORT_NAME: 'Report Name',
  REPORT_NAME_PLACEHOLDER: 'Enter Report Name',
  DATE_RANGE: 'Date Range',
  DATE_FROM_LABEL: 'From',
  DATE_TO_LABEL: 'To',
  TIME_PERIOD: 'Time Period',
  TIME_PERIOD_PLACEHOLDER: 'Select Time Period',
  LINE_OF_BUSINESS: 'Line of Business',
  LINE_OF_BUSINESS_PLACEHOLDER: 'All',
  SELECT_FIELD: 'Select Fields',
  RESET_TO_DEFAULT: 'Reset to Default',
  SAVE_PARAMETERS: 'Save Parameters',
  UPDATE_PARAMETERS: 'Update Parameters',
  GENERATE_PREVIEW: 'Preview',
  RUN_REPORT: 'Export',
  HCOName: 'HCO Name: ',
  NumberOfTins: 'Number of TINs: ',
  Region: 'Region: ',
  Datecreated: 'Date Created: ',
  Daterange: 'Date Range: ',
  View: 'View',
  Customreports: 'Custom Reports',
  ClaimsReportSavedSuccess: 'Claims report parameters saved successfully!',
  ClaimsReportSavedError: 'Failed to save claims report parameters. Please try again.',
  DeleteErrorMessage: 'Failed to delete claims report. Please try again.',
  Apply: 'Apply',
  NO_RESULT_FOUND: 'No results found',
  SELECT_OPTIONS: 'Select options',
  SEARCH_PLACEHOLDER: 'Search...',
  RESET_FILTER: 'Reset Filter',
  ROWS_PER_PAGE: 'Rows per page:',
  CLEAR_SELECTIONS: 'Clear Selections',
  REPORT_CAPTIONS: {
    TOP: 'Generating Report Preview',
    BOTTOM: 'This may take a few moments.'
  },
  VIEW_REPORT_BY: {
    VIEW_REPORT: 'View Custom Report By: ',
    DOS: 'Date of Service',
  },
  SAVE_LIMIT_MODAL: {
    TITLE: "You've reached your saved report limit.",
    SUBTITLE:
      'You can save up to 6 reports. Delete an existing report below to save a new one.',
    CANCEL: 'Cancel',
  },
};

export const MAX_SAVED_REPORTS = 6;

const ALL_FLOW_DEFAULT_SELECTED_FIELDS: string[] = [
  'Claims Received Date',
  'Claim Processed Date',
  'Claim Allowed Amount',
  'Claim Paid Amount',
  'Claim Total Charge',
  'Line Identifier',
  'Claim Number',
];

export const HCO_DEFAULT_SELECTED_FIELDS: string[] = [
  ...ALL_FLOW_DEFAULT_SELECTED_FIELDS,
  'HCO Name'
];

export const TIN_DEFAULT_SELECTED_FIELDS: string[] = [
  ...ALL_FLOW_DEFAULT_SELECTED_FIELDS,
  'Claim Bill Provider TIN'
];

export const GEO_DEFAULT_SELECTED_FIELDS: string[] = [
  ...ALL_FLOW_DEFAULT_SELECTED_FIELDS,
  'Region',
  'Market',
  'Claim Billing Provider State',
];

export const TIME_PERIOD_OPTIONS = [
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'Last 3 Months', value: 'Last 3 Months' },
  { label: 'Last 6 Months', value: 'Last 6 Months' },
  { label: 'Last 12 Months', value: 'Last 12 Months' },
  { label: '2025', value: '2025' },
  { label: '2024', value: '2024' },
  { label: 'Custom Range', value: 'CustomRange' },
];

export const LOB_MAPPINGS: { [key: string]: string } = {
  'Commercial': 'Commercial',
  'Individual Exchange': 'Individual Exchange',
  'Medicare': 'Medicare',
  'Medicaid': 'Medicaid',
};

export const AMOUNT_COLUMN_NAMES = new Set([
  'Claim Allowed Amount',
  'Claim Paid Amount',
  'Billed Amount',
  'Line Allowed Amount',
  'Line Paid Amount',
  'Line Charge Amount',
  'Claim Total Charge'
]);

export const DEFAULT_PAGE_SIZE = 20;